import { ensureSingleTagExists, ensureTagNotExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

export interface IHasVideoTag {
  type: 'advanced-has-video';
}

function isHasVideoTag(tag: TTag): tag is IHasVideoTag {
  return tag.type === 'advanced-has-video';
}

export const hasVideoTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery, tagsData, location) => {
    const value = jsonQuery.has_video && jsonQuery.has_video.value;

    if (value) {
      return ensureSingleTagExists(tags, isHasVideoTag, previousTag => ({ type: 'advanced-has-video' }));
    }

    return ensureTagNotExists(tags, isHasVideoTag);
  },
};
